import lpApp from '../lp_app';
import { lpIdGetPure } from '../../logic/global_getter';
import ConditionsEvo from '../../logic/condition_evo';

/*
 * Project: LegalPlace assistant
 * File: src/app/indexes/conditions.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
*/

class LpConditionsIndex {
  constructor() {
    this.conditions = {};
  }

  updateConditions() {
    let keys;
    if (!lpApp.indexes.options.isLoaded()) return;
    const la = lpApp.action_tracker.last_action;
    if (la === 'EDIT_OPTION_RADIO_' || la === 'SET_SECTION_ID' || la === 'EDIT_OPTION_VALUE_') {
      keys = lpApp.indexes.dependencies.getDependecies(lpIdGetPure(lpApp.action_tracker.la_arg1));
      if (keys) {
        keys.forEach((idx) => {
          const now = lpApp.references.options[idx].meta;
          if (now.conditional && (now.compiledConditions.length > 0)) {
            // let c = new ConditionRuntime(now.compiledConditions);
            // c.compileDirect()
            // // console.log(c)
            // this.conditions[idx] = c.execute(true);

            this.conditions[idx] = ConditionsEvo.getCondition(idx);
          }
        });
      }
    }
  }

  getCondition(cond) {
    return this.conditions[cond];
  }

  setCondition(cond, val) {
    this.conditions[cond] = val;
  }

  buildConditions(tree) {
    this.conditions = tree;
  }
}

export default LpConditionsIndex;



// WEBPACK FOOTER //
// ./src/app/indexes/conditions.js